module.exports = "/build/web/svg/icon-phone.ffbc0f63587e5da49c28d1d4378504ea.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-phone.svg
// module id = 142
// module chunks = 11